class PopoutCart extends HTMLElement {
  
  constructor(){
    super();
    this.listeners();
    this.bindCloseEvents();
  }

  listeners(){
    const openButtons = document.querySelectorAll('.js-popout-cart-open');
    const closeButtons = document.querySelectorAll('.js-popout-cart-close');
    const popoutCartItemsWrapper = this.querySelector('.js-popout-cart-items-wrapper');
    const shade = this.querySelector('.js-shade');

    document.addEventListener('popout-cart:show', () => {
      this.openCart();
    });

    document.addEventListener('popout-cart:close', () => {
      this.closeCart();
    });

    openButtons.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.openCart();
      });
    });

    closeButtons.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeCart();
      });
    });

    if (shade) {   
      shade.addEventListener('click', this.closeCart);
    }

    document.addEventListener('cart:requestStart', (e) => {
      if (e.detail && e.detail.qtyChange) return;
      
      if (popoutCartItemsWrapper) {
        popoutCartItemsWrapper.scrollTop = 0;
      }
    });

    document.addEventListener('cart:requestComplete', (e) => {this.paintPopoutCart(e)});
    document.addEventListener('cart:updated', this.bindCloseEvents.bind(this));
  }

  bindCloseEvents() {
    const cartCloseButtons = this.querySelectorAll('.js-popout-cart-close');

    cartCloseButtons.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeCart();
      });
    })
  }

  openCart() {
    const body = document.querySelector('body');
    body.classList.add('popout-cart-active');
  }

  closeCart() {
    const body = document.querySelector('body');
    body.classList.remove('popout-cart-active');
  }

  paintPopoutCart(e) {
    if (e.detail.data.sections) {
      const sections = [
        {
          section: e.detail.data.sections['stmt-popout-cart-delivery-banner'],
          target: document.querySelector('.js-popout-cart-delivery-banner')
        },
        {
          section: e.detail.data.sections['stmt-popout-cart-items'],
          target: document.querySelector('.js-popout-cart-items')
        },
        {
          section: e.detail.data.sections['stmt-popout-cart-footer'],
          target: document.querySelector('.js-popout-cart-footer')
        }
      ];

      sections.forEach((el) => {
        if (el.target && el.section) {
          el.target.innerHTML = el.section;
        }
      });
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
}

customElements.define('popout-cart', PopoutCart);
